// extracted by mini-css-extract-plugin
export default {"loading-container":"loading_loading-container__JRu7t"};